// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"_3X5FB","active":"sz-ht","blueActiveTab":"_1EA3Q"};